import apiRequest from "../utils/ApiRequest/apiRequest.js";

/**
 * logger function to 'throw exception' to aws log and/or console
 * @param file - string - where it happened. file name
 * @param method - string - related function name
 * @param exception - string - thrown exception (e)
 * @param aws - boolean -is write to aws log?
 * @param console - boolean - is write to browser console?
 *
 */
const logger = (
  file,
  method,
  exception = null,
  aws = false,
  isWriteToConsole = true
) => {
  if (isWriteToConsole) {
    console.log(`[${file}] ${method} > ${exception}`);
  }
  if (aws) {
    apiRequest(
      "Health",
      "createLog",
      {
        file: { file },
        method: { method },
        exception: { exception },
      },
      "POST"
    );
  }
  return null;
};

logger.defaultProps = {
  file: "",
  method: "",
  exception: null,
  aws: false,
  console: false,
};

export default logger;
